import { useState } from "react";
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { getDetailProject } from "../../../services/devsServices";
import { useDispatch, useSelector } from "react-redux";
import { unsetAuth } from "../../../../../helpers/authHelper";
import { getAuthToken } from "../../../../../helpers/authHelper";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../../../../redux/store";
import { logoutAction } from "../../../../../redux/features/auth";

export const useDetailProjectModel = () => {
  const user = useSelector((store: AppStore) => store.auth);
  const token = require("../../../../../helpers/authHelper").getAuthToken(user);
  const { country } = useSelector((store: AppStore) => store.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [detailProject, setDetailProject] = useState({});
  const [detailProjectLoading, setDetailProjectLoading] = useState(false);
  const { callEndpoint } = useCallApiAndLoad();

  const getDataDetailModel = async (id: string) => {
    if (Object.keys(detailProject).length > 0) return; // Si ya hay datos, no consultar
    setDetailProjectLoading(true);
    try {
      const { status, data } = await callEndpoint(getDetailProject(token, id));
      if (status === 401) {
        setDetailProjectLoading(false);
        dispatch(logoutAction({}));
        unsetAuth();
        navigate(`/app/${country}/auth/desarrolladoras/login`);
      }
      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setDetailProjectLoading(false);
        setDetailProject(response.data);
      }
    } catch (error) {
      setDetailProjectLoading(false);
      console.log(error);
    }
  };

  return { detailProject, detailProjectLoading, getDataDetailModel };
};
